import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import FileUpload from './FileUpload'
import TextEditor from '../../../../components/TextEditor'
import { axiosInstance } from '../../../../const/axiosInstance'
import styles from './edit.module.css'

export default function EditLeaders({add}) {
    const [leader, setLeader] = useState(null)
    const [image, setImage] = useState('/uploads/avatar.jpg')
    const [name, setName] = useState('')
    const [terms, setTerms] = useState('')
    const [information, setInformation] = useState('')
    const [language, setLenguage] = useState("")
    const [fromLang, setFromLang] = useState(false)

    const {id} = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        (async () => {
            if(!add){
                const res = await axiosInstance.get(`/use/leader/${id}`)
                if(res.data.status){
                    setLeader(res.data.data)
                    setImage(res.data.data.image)
                    setTerms(res.data.data.terms)
                }
            }
            setLenguage("arm")
            })()
    },[])

    useEffect(() => {
        if( name !== "" && information !== '' && information !== '<p></p>\n'){
            setLeader(prev => ({...prev, [`${language}name`]: name, [`${language}information`]: information }))
        }
    }, [information, name])

    useEffect(() => {
        if(language){
            if(!add){
                setFromLang(true)
                setName(leader[`${language}name`])
                setInformation(leader[`${language}information`])
            }else{
                setName("")
                setInformation("")
            }
        }
      
    }, [language])


    const changeLanguage = async () => {
        if(name && information){
            if(language == "arm"){
               setLenguage("ru")
            }
            if(language == "ru"){
                setLenguage("eng")
            }
        }else{
            return 
        }
    }
  

    useEffect(() => {
        setLeader(prev => {return {...prev, image}})
    }, [image])

    useEffect(() => {
        setLeader(prev => {return {...prev, terms}})
    }, [terms])

    const addLeader = async () => {
        await axiosInstance.post(`/admin/leaders/add`, leader)
        navigate("/dashboard/leaders")
    }

    const editLeader = async () => {
        await axiosInstance.post(`/admin/leaders/edit`, leader)
        navigate("/dashboard/leaders")
    }



  return (
    <div className={styles['edit-part']}>
        <h2>{language == "arm" ? "Հայերեն" : language == "ru" ? "Ռուսերեն" : "Անգլերեն"}</h2>
        <div className={styles['upload']}>
            <p>Ներբեռնել ղեկավարի նկարը։ </p>
            <FileUpload setImage={setImage}/>  
            <input disabled={true} placeholder='ֆայլ' value={image}/>
        </div>
        <div className={styles['info']}>
            <p>Ղեկավարի անուն, ազգանուն։ </p>
            <input type='text' placeholder='Անուն Ազգանուն' value={name} onChange={(e) => setName(e.target.value)}/>
        </div>
        <div className={styles['info']}>
            <p>Ապրել է։ </p>
            <input type='text' placeholder='2000-2010' value={terms} onChange={(e) => setTerms(e.target.value)}/>
        </div>
        <div>
            <p>Ղեկավարի մասին: </p>
            <TextEditor setInformation={setInformation} information={information} fromLang={fromLang} setFromLang={setFromLang}/>
        </div>
        <div className={styles['btn-div']}>
            {language != "eng" ? 
                    <button className={`${styles['btn']} ${styles['confirm']}`} onClick={changeLanguage}>Հաջորդ</button> 
                    : !name || !information || !image || !terms || information == '<p></p>\n' ? <button disabled className={`${styles['btn']} ${styles['confirm']}`}>Հաստատել</button>
                    :
                    <button className={`${styles['btn']} ${styles['confirm']}`} onClick={add ? addLeader : editLeader}>Հաստատել</button>}
            <Link to='/dashboard/leaders'><button className={`${styles['btn']} ${styles['cancel']}`}>Չեղարկել</button></Link>
        </div>
    </div>
  )
}
